const theme = {
  // named colors:
  brand: '#663399',
  brandLight: '#9d7cbf',
  brandLightest: '#e0d6eb',
  brandDarkened: '#215f96',
  accent: '#4edb9b',
  accentDarkened: '#39a172',
  gatsby: '#663399',
  gatsbyLight: '#9d7cbf',
  gatsbyLightest: '#e0d6eb',
  gatsbyGreen: '#7CBF9F',
  elixirRed: '#FF6666',
  elixirRedLight: '#FF6666',
  darkGrey: '#35495E',
  lightGrey: '#d8d8d8',
  greyBackground: '#F5F3F7',
  greyBackgroundDarker: '#515152',

  ink: '#333333',
  inkLight: '#bbbabd',
  linkBackground: 'rgba(157,125,191,.04)',

  matShadow: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);',

  // Vue docs text editor colors
  errorRed: '#FF6666',
  codeEditBlue: '#2973b7',
  codeEditGreen: '#42b983',

  // spacing:
  spacingUnit: scale => `${scale * 10}px`,

  // content width:
  contentWidthLaptop: '850px',
  sitePadding: '25px',
}

export default theme

/*
  brand: "#19456e",
  brandSlightLight: "#1b4a76",
  brandLightened: "#2f84d2",
  brandDarkened: "#215f96",
 */



// WEBPACK FOOTER //
// ./src/layouts/theme.js